import { useDataSubmit, useDataChange, useDataValue } from 'Simple/Data.js'

export function useOnClick(props) {
  let submit = useDataSubmit({
    context: 'tab',
    viewPath: props.viewPath,
  })

  let change = useDataChange({
    context: 'selected',
    path: 'bulk_task_ids',
    viewPath: props.viewPath,
  })

  let task_ids = useDataValue({
    context: 'selected',
    path: 'bulk_task_ids',
    viewPath: props.viewPath,
  })

  let stages = useDataValue({
    context: 'board',
    path: 'stages',
    viewPath: props.viewPath,
  })

  return function onClick() {
    submit({
      type: 'set_bulk_tasks_stage',
      task_and_stage_ids: task_ids.map(task_id => ({
        id: task_id,
        stage_id: stages.find(stage => stage.done)?.id,
      })),
    })

    change([])
  }
}
